import React, { Component } from 'react';
import autobind from 'react-autobind';
import translate from 'app/translations';
import { Layout } from 'antd';

import solidifiLogo from 'assets/images/solidifi-logo.svg';

export class Footer extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  render() {
    return (
      <div className="box-shadow">
        <Layout.Footer>
          <div className="align-right">
            <img src={solidifiLogo} alt={this.t('Generic.solidifiLogo')} />
            <div>
              {this.t('Footer.aRmCo')}
            </div>
            <div id="copywrite">
              {this.t('Footer.copywrite', { year: new Date().getFullYear() })}
            </div>
          </div>
        </Layout.Footer>
      </div>
    );
  }
}

export default Footer;
